"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const keycode_1 = __importDefault(require("keycode"));
const react_1 = require("react");
const common_components_1 = require("@zapier/common-components");
const common_utils_1 = require("@zapier/common-utils");
const ChoiceGroupBody_1 = __importDefault(require("./ChoiceGroupBody"));
const ChoiceGroupHeader_1 = __importDefault(require("./ChoiceGroupHeader"));
const ChoiceItemsContainer_1 = __importDefault(require("./ChoiceItemsContainer"));
const CustomMapperStyles_1 = __importDefault(require("./CustomMapperStyles"));
const CustomMapperButton_1 = __importDefault(require("./CustomMapperButton"));
const ChoiceGroupContainer = ({ group, isInitiallyOpen = false, isShowingAll, onSelect, onShowGroupOptions, }) => {
    const [isGroupOpen, setIsGroupOpen] = react_1.useState(isInitiallyOpen);
    const onShowAllOptions = react_1.useCallback(() => onShowGroupOptions(group.groupId), [onShowGroupOptions, group.groupId]);
    const onShowTopOptions = react_1.useCallback(() => onShowGroupOptions(null), [
        onShowGroupOptions,
    ]);
    if (isShowingAll) {
        return (common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.choiceGroupContainer },
            common_utils_1.isolateComponent(CustomMapperButton_1.default, { color: "customBlack", iconBefore: "arrowSmallLeft", onClick: onShowTopOptions }, "Go Back"),
            common_utils_1.isolateComponent(ChoiceItemsContainer_1.default, { items: group.items, onSelect: onSelect })));
    }
    const toggleAccordion = () => {
        setIsGroupOpen(!isGroupOpen);
    };
    const onKeyDown = (e) => {
        if (e.keyCode === keycode_1.default('enter') || e.keyCode === keycode_1.default('space')) {
            setIsGroupOpen(!isGroupOpen);
        }
    };
    return (common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.choiceGroupContainer },
        common_utils_1.isolateComponent(common_components_1.AccordionHeader, { isOpen: isGroupOpen },
            common_utils_1.isolateComponent(ChoiceGroupHeader_1.default, { group: group, isOpen: isGroupOpen, onClick: toggleAccordion, onKeyDown: onKeyDown })),
        common_utils_1.isolateComponent(common_components_1.AccordionContent, { isOpen: isGroupOpen }, isGroupOpen && (common_utils_1.isolateComponent(ChoiceGroupBody_1.default, { items: group.items || [], onSelect: onSelect, onShowAllOptions: onShowAllOptions })))));
};
exports.default = ChoiceGroupContainer;
